import React from "react";
import TemplateSvgPreview from "../../../pages/CertificateOnboarding/configure/TemplateSvgPreview";
import VariableConfigPanel from "../../../pages/CertificateOnboarding/configure/VariableConfigPanel";

function CertificateConfigureStep({
  cleanupData,
  variableConfig,
  setVariableConfig,
  qrCodeType,
  onQrCodeTypeChange,
  userAddedVariableKeys,
  onAddVariable,
  onRemoveVariable,
  t,
}) {
  return (
    <div
      id="cert-onboarding-configure-step"
      className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 items-start"
    >
      <div className="lg:col-span-5 xl:col-span-4">
        <TemplateSvgPreview
          templateSvgUrl={cleanupData?.template_svg_url}
          previewSvgUrl={cleanupData?.preview_svg_url}
          variableConfig={variableConfig}
          enableFillDefaultsPreview
          t={t}
        />
      </div>
      <div className="lg:col-span-7 xl:col-span-8 flex flex-col min-h-0">
        <div className="lg:max-h-[calc(100vh-11rem)] lg:overflow-y-auto lg:overflow-x-hidden lg:pr-1 scroll-smooth [scrollbar-gutter:stable]">
          <VariableConfigPanel
            variableConfig={variableConfig}
            setVariableConfig={setVariableConfig}
            qrCodeType={qrCodeType}
            onQrCodeTypeChange={onQrCodeTypeChange}
            userAddedVariableKeys={userAddedVariableKeys}
            onAddVariable={onAddVariable}
            onRemoveVariable={onRemoveVariable}
            t={t}
          />
        </div>
      </div>
    </div>
  );
}

export default CertificateConfigureStep;
